import React from 'react';

import { ExpandablePanel } from 'src/components/sidebar/src/expandable-panel';
import { MediaAuth } from 'src/hooks/media';
import PullRequestOverviewActivity from 'src/sections/repository/sections/pull-request/containers/pull-request-overview-activity';

import { ActivityPanelTitle } from './activity-panel-title';

const ACTIVITY_KEY = 'pull-request.overview.activity.expanded';

/**
 * Renders the activity feed panel on the pull request overview tab.
 *
 * @returns The rendered activity feed panel component.
 */

/* eslint @typescript-eslint/ban-types: "warn" */
export const ActivityFeedPanel: React.FC<{ mediaAuth: MediaAuth }> = ({
  mediaAuth,
}) => {
  return (
    <ExpandablePanel header={<ActivityPanelTitle />} storageKey={ACTIVITY_KEY}>
      <PullRequestOverviewActivity mediaAuth={mediaAuth} />
    </ExpandablePanel>
  );
};
